import React from 'react';
import { Checkbox } from 'semantic-ui-react';
import './styles.scss';
import { withTranslation } from "react-i18next";
import { compose } from 'redux';
import Table,  { Column } from 'react-base-table';
import 'react-base-table/styles.css'
import _ from 'lodash';
import { commonConstants } from '../../core/constant/common.constants';

class TableDateCustom extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectRow: '',
            sort: 'ASC',
            classSort: 'descending sorted',
            headerClick: '',
            totalOTByDate: [],
            totalAllProject: '',
            dataSource: [],
            loading: true
        }
    }

    componentWillMount() {
        const { dataList, totalOTDate } = this.props;
        this.setState({
            dataList: dataList || [],
            totalOTByDate: totalOTDate || []
        })
        
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.unSelectRow !== true) {
            this.setState({
                selectRow: ''
            })
        }

        if (nextProps.defaultSort && nextProps.defaultSort.indexOf("ASC") !== -1) {
            this.setState({
                sort: 'ASC',
                classSort: 'descending sorted',
                headerClick: ''
            })
        }

        this.setState({
            dataList: nextProps.dataList || [],
            totalOTByDate: nextProps.totalOTDate || [],
            totalAllProject:  nextProps. totalAllProject|| '',
            tableStructure: nextProps.tableStructure
        }) 
    }

    // handle row click
    handleRowClick = (val) => {
        this.setState({ selectRow: val['projectId'] });
        this.props.onRowClick(val);
    }

    // handle row click
    handleCellClick = (val, projectId, status) => {
        if (this.props.onCellClick && status !== 'day-approved') {
            this.props.onCellClick(val, projectId);
        } 
        
    }

    // handle click Sort
    handleSort = async (val) => {
        await (this.state.sort === 'ASC') ? (this.setState({
            sort: 'DESC',
            classSort: 'ascending sorted',
            headerClick: val
        })) : (
                this.setState({
                    sort: 'ASC',
                    classSort: 'descending sorted',
                    headerClick: val
                })
            );

        return this.props.sortBy(this.state.headerClick + '-' + this.state.sort);
    }

    checkStatus = (checkValue) => {
        let status = '';

        if (this.props.listCheckStatus !== undefined) {
            this.props.listCheckStatus.map((subItem) => {
                if (checkValue !== undefined && checkValue.indexOf(subItem.date) === 0) {
                    if (subItem['checkStatus']) {
                        status = 'day-approved';
                    }
                }
            })
        }

        return status;
    }
    
    render() {
        const { tableStructure, t, dataList, disableLeave } = this.props;

        // Set Structure table 
        const columns = _.map(tableStructure, (state, index) => ({
            title: !state.isDate ? t(state['label']) : state['label'],
            dataKey: state['isDate'] ? 'data' + index : (state['mainType'] ? state['mainType'] : state['type'] ),
            key: state['type'] + index ? state['type'] + index : 'data' + index,
            className: this.checkStatus(state.checkValue) + ' ' + (state.isClass ? state.isClass : ''),
            headerClassName: this.checkStatus(state.checkValue) + ' ' + (state.isClass ? state.isClass : ''),
            frozen: state['fixed'] ? state['fixed'] : false,
            width: state['width'],
            state: state,
            cellProps:(record, index) => {
                return {
                    onDoubleClick: event => {
                        this.handleCellClick(state, record.id, this.checkStatus(state.checkValue))   
                    }
                    
                };
            }
            
        }))

        // Set data table
        let dataSource = dataList;
        _.map(dataList, (data, index) => {
            _.map(tableStructure, (structureValue, i) => {
                if (structureValue.isDate) {
                    let row = '';
                    if (data[structureValue['subType']]) {
                        _.map(data[structureValue['subType']], (workLogValue, i) => {
                            if (workLogValue['date'] === structureValue['checkValue']) {
                                row = workLogValue[structureValue['type']]
                            }
                        })
                    } 
                    dataSource[index]['data' + i] = row;
                } else {
                    if (structureValue.type === 'id') {
                        dataSource[index]['id'] = index + 1;
                    }
                    if (structureValue.typeCombine !== undefined) {
                        let codeName = data[structureValue.type] + ' - ' + data[structureValue.typeCombine]
                        dataSource[index][structureValue.mainType] = codeName;
                    }
                }   
            })
        })

        // Set total row
        let dataTotal = [];
        const totalDate = this.state.totalOTByDate;
        let totalRow = {}
        if (tableStructure[0]['mainType']) {
            totalRow[tableStructure[0]['mainType']] = t('table.total');
        } else {
            totalRow[tableStructure[0]['type']] = t('table.total');
        }
       
        totalRow['totalHours'] = this.state.totalAllProject;
        _.map(tableStructure, (structureValue, index) => {
            if (structureValue.isDate) {
                totalRow['isTotal'] = true;
                _.map(totalDate, (date, key) => {
                    if (structureValue.day === key) {
                        totalRow['data' + index] = date;
                    }
                })
            }
           
        })
        dataTotal[0] = totalRow;
        
        let data = [];
        if (this.props.isTotal) {
            if (this.props.isTotalFirst) {
                data = dataSource.concat();
                if (dataSource && dataTotal) {
                    data = dataTotal.concat(dataSource);
                }
            } else {
                if (dataSource && dataTotal) {
                    data = dataSource.concat(dataTotal);
                }
                
            }
        } else data = dataSource;
           
        return (
            <div className="table-list table-scroll table-readonly">
               <Table 
                    fixed
                    width={Number(this.props.width)}
                    maxHeight={Number(this.props.maxHeight)}
                    bordered
                    data={data} 
                    columns={columns} 
                    pagination={false} 
                    className='project-table-date'
                    rowClassName={(record, index) => {
                        if (
                            record.rowData &&
                            record.rowData.projectCode &&
                            commonConstants.DISABLED_PROJECT.findIndex((ele) => ele === record.rowData.projectCode) >= 0 &&
                            disableLeave
                        ) {
                            return record.rowData.isTotal ? "table-total" : "BaseTable--disabled";
                        } else return record.rowData.isTotal ? "table-total" : "";
                    }}
                    headerHeight={30} rowHeight={30}
                    cellProps={(record, index) => {
                        return {
                            onDoubleClick: event => {
                                this.handleCellClick(record.column.state, record.rowData.id, this.checkStatus(record.column.state.checkValue))   
                            }
                            
                        };
                    }}
                    
                />
            </div>
        );
    }
}

export default compose(
    withTranslation(),
)(TableDateCustom);
